/**
 * Converts the list of available labels to a list of options we can use in our components
 */
export function getLabelOptions(options: UserLabels) {
  return options.map((option) => ({
    value: option.value,
    label: option.name,
  }));
}
